// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__23qBd","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1R7pB"};